module.exports = __webpack_public_path__ + "img/sensor-disconnected-dark-grey.074ef640.png";